import React, {useEffect, useState} from "react";
import "../styles/ReviewStars.css"; // ✅ CSS 파일 연결

const ReviewStars = ({onRatingChange}) => {
    const [rating, setRating] = useState(0); // ⭐ 실제 선택된 별점
    const [hoverRating, setHoverRating] = useState(0); // ⭐ 호버 시 별점

    useEffect(() => {
        onRatingChange(rating);
    })

    // ⭐ 별점 메시지
    const ratingMessages = {
        0: "별점을 선택해주세요",
        1: "별로다옹",
        2: "아쉽다옹",
        3: "보통이다옹",
        4: "만족이다옹",
        5: "최고다옹",
    };

    return (
        <div className="review-stars">
            {/* ⭐ 별점 선택 안내 */}
            <p className="review-stars-title">별점을 선택해주세요</p>

            {/* ⭐ 별점 UI */}
            <div
                className="review-stars-container"
                onMouseLeave={() => setHoverRating(0)} // 마우스 벗어나면 초기화
            >
                {[1, 2, 3, 4, 5].map((index) => (
                    <span
                        key={index}
                        className={`rewiew-modal-star ${hoverRating >= index || rating >= index ? "active" : ""}`}
                        onMouseEnter={() => setHoverRating(index)}
                        onClick={() => setRating(index)}
                    >
                        ★
                    </span>
                ))}
            </div>

            {/* ⭐ 별점 메시지 */}
            <p className="review-stars-score">
                {rating}점 (<b>{ratingMessages[rating]}</b>)을 남겨주셨네요.
                구체적인 내용을 작성해 주세요!
            </p>
        </div>
    );
};

export default ReviewStars;
